import React, { useEffect } from 'react';
import { Route, unstable_HistoryRouter as HistoryRouter, Routes } from 'react-router-dom';
import { Home } from './home';
import { useFeatureServices } from './use-feature-services';
import { IntroQuizGti50 } from './components/quizGti50/introQuizGti50';
import { QuizFormLoader } from './components/quizGti50/quizFormLoader';

export function App(): JSX.Element {
  const { 's2:history': historyService } = useFeatureServices();

  useEffect(() => {
    const unregister = historyService.history.listen(() => {
      console.log('history changes', historyService.history.location.pathname);
    });
    return unregister;
  });

  console.log('pathname', historyService.history.location.pathname);

  return (
    <HistoryRouter history={historyService.history}>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/quiz" element={<IntroQuizGti50 />}></Route>
        <Route path="/mas-informacion" element={<QuizFormLoader onClose={function (): void {
          throw new Error('Function not implemented.');
        } } errorCount={''} />}></Route>
      </Routes>
    </HistoryRouter>
  );
}
